import "jquery";
import * as ko from "knockout";
import { BaseCropComponent } from "./BaseCropComponent";
import { OsrTrade } from "../Models/Osr/OsrTrade";

export class OsrTrades extends BaseCropComponent<OsrTrade> {
    constructor() {
        super($('#osrtrades-table'));
    }
    init(): void {
        this.osrApi.getTrades().then((res) => {
            super.init(res);
        });
    }
}